import React from 'react'

import BackDrop from './../../../resources/HomePageResources/london.svg'
import PlatformLeft from  './../../../resources/HomePageResources/platform-down-left.svg'
import PlatformRight from  './../../../resources/HomePageResources/platform-down-right.svg'
import '../../../styles/HomePageStyles/PlatformStyles/london.css'
import LondonMan from './../../../resources/HomePageResources/london-man.svg'
import LondonBank from './../../../resources/HomePageResources/london-bank.svg'
import LondonCoin from './../../../resources/HomePageResources/london-coin.svg'
import LondonSign from './../../../resources/HomePageResources/london-sign.svg'
import LondonLogo from './../../../resources/HomePageResources/london-logo.svg'
import LondonHotAir from './../../../resources/HomePageResources/sydney-balloon.svg'
import LondonPipe from './../../../resources/HomePageResources/pipes/london-pipe.svg'

import LondonBridgeOne from './../../../resources/HomePageResources/london-bridge-1.svg'
import LondonBridgeTwo from './../../../resources/HomePageResources/london-bridge-2.svg'
import LondonWheel from './../../../resources/HomePageResources/london-wheel.svg'


export default class LondonPlatform extends React.Component{
    render(){
        return(
            <div className="plat__container" style={{width: '360px'}}>
                <div className="plat__backdrop">
                    <img className="plat__backdrop-img" src={BackDrop} />
                    <img className="london__b-1" src={LondonBridgeOne} />
                    <img className="london__b-2" src={LondonBridgeTwo} />
                    <img src={LondonWheel} className="london__wheel" />
                    <div className="plat__content-box london-content-box">

                        <div className="london__flight-path">
                            <img className="london__plane" src={LondonHotAir}/>
                        </div>

                        <div className="tokyo__baseline">

                            <div className="london__man">
                                <img className="london__man-img" src={LondonMan}/>
                                <div className="london__coin">
                                    <img style={{width: '20px'}} src={LondonCoin}/>
                                </div>
                                <div className="london__coin-two">
                                    <img style={{width: '20px'}} src={LondonCoin}/>
                                </div>
                                <div className="london__coin-three">
                                    <img style={{width: '20px'}} src={LondonCoin}/>
                                </div>
                            </div>

                            <div className="london__bank">
                                <img className="london__bank-img" src={LondonBank}/>
                            </div>



                        </div>

                    </div>
                </div>

                <div className="plat__platform">
                    <img className="plat__platform-left" src={PlatformLeft} />
                    <div className="plat__platform-middle" />
                    <img className="plat__platform-right" src={PlatformRight} />
                </div>
                <div className="london__pipe">
                    <img src={LondonPipe} />
                    <div className="london-pipe-c-1"/>
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/HomePage/Platforms/LondonPlatform.js